import styled from 'styled-components'

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ContainerRows = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 29vh;
  overflow-y: auto;
`

export const Row = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  padding-left: .2rem;
  padding-right: .2rem;
  padding-top: .1rem;
  padding-bottom: .1rem;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 25%;
`
